import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';

import {
  isPendingAction,
  isRejectedAction,
  isFulfilledAction
} from './actions';

import { processData } from './mockData/processData';

const name = 'processes';

export const studentProcesses = createAsyncThunk(
  `${name}/studentProcesses`,
  async (_, { rejectWithValue }) => {
    try {
      //const responseFromApi = await axios.get('/api/processes');
      //const response = processData;
      //return response;

      return;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// export const getStudentProcesses = () => {
//   try {
//     const response = processData;
//     return response;
//   } catch (error) {
//     return rejectWithValue(error.response.data);
//   }
// };

const applicationSlice = createSlice({
  name,
  initialState: {
    loading: false,
    errors: false,
    processes: processData
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(studentProcesses.fulfilled, (state, action) => {
        state.processes = action.payload;
      })
      .addMatcher(isPendingAction(name), (state) => {
        state.loading = true;
        state.errors = false;
      })
      .addMatcher(isRejectedAction(name), (state, action) => {
        state.loading = false;
        state.errors = action.payload;
      })
      .addMatcher(isFulfilledAction(name), (state) => {
        state.loading = false;
      });
  }
});

export default applicationSlice.reducer;
